import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnterprisePlanIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 30 30",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M20.6667 9.3335C20.3865 9.33349 20.1126 9.41656 19.8797 9.57222C19.6467 9.72789 19.4651 9.94914 19.3579 10.208C19.2506 10.4669 19.2226 10.7517 19.2772 11.0265C19.3319 11.3013 19.4668 11.5538 19.6649 11.7519C19.863 11.95 20.1155 12.085 20.3903 12.1396C20.6651 12.1943 20.9499 12.1663 21.2088 12.059C21.4677 11.9518 21.6889 11.7702 21.8446 11.5373C22.0003 11.3043 22.0834 11.0304 22.0834 10.7502C22.0834 10.3745 21.9341 10.0141 21.6685 9.74845C21.4028 9.48277 21.0425 9.33351 20.6667 9.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M20.6667 20.6669C20.9469 20.6669 21.2208 20.5838 21.4538 20.4281C21.6867 20.2724 21.8683 20.0512 21.9755 19.7923C22.0828 19.5334 22.1108 19.2486 22.0561 18.9738C22.0015 18.699 21.8665 18.4465 21.6684 18.2484C21.4703 18.0503 21.2178 17.9154 20.943 17.8607C20.6682 17.8061 20.3834 17.8341 20.1245 17.9414C19.8656 18.0486 19.6444 18.2302 19.4887 18.4632C19.3331 18.6961 19.25 18.97 19.25 19.2502C19.25 19.4363 19.2866 19.6205 19.3578 19.7924C19.429 19.9642 19.5334 20.1204 19.6649 20.252C19.7965 20.3835 19.9527 20.4879 20.1245 20.559C20.2964 20.6302 20.4806 20.6669 20.6667 20.6669Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.98346 15.3545H0.851562C0.933344 18.8151 2.28566 22.1245 4.65074 24.6521C6.04234 23.2387 7.7081 22.1245 9.54579 21.378C9.21217 19.3865 9.02423 17.3733 8.98346 15.3545Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.67747 22.0835C7.97581 22.7977 6.43375 23.8442 5.1416 25.1618C7.34921 27.3077 10.1981 28.6727 13.2538 29.0485C11.317 27.9344 10.2559 24.995 9.67747 22.0835Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.748 29.048C19.8033 28.672 22.6519 27.3072 24.8592 25.1615C23.5627 23.8399 22.0146 22.7912 20.3064 22.0771C19.5925 25.7334 18.3816 28.0993 16.748 29.048Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3064 7.923C22.0146 7.20893 23.5626 6.1602 24.8592 4.83861C22.6519 2.69298 19.8033 1.32812 16.748 0.952148C18.3816 1.90091 19.5925 4.26678 20.3064 7.923Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8348 14.8355L20.8554 12.8561C20.7922 12.8614 20.7314 12.8751 20.6669 12.8751C20.2047 12.8763 19.7547 12.7264 19.3856 12.4481C19.0165 12.1699 18.7485 11.7786 18.6223 11.334C18.4962 10.8893 18.5188 10.4156 18.6868 9.98495C18.8549 9.55434 19.159 9.19046 19.553 8.94873C18.1964 9.39349 16.7818 9.63659 15.3545 9.67022V14.646H17.2471C17.4797 14.6454 17.7102 14.6909 17.9251 14.7799C18.14 14.869 18.3351 14.9998 18.4991 15.1648L20.4785 17.1442C20.5416 17.1386 20.6024 17.1252 20.667 17.1252C21.2306 17.1252 21.7711 17.3491 22.1696 17.7476C22.5681 18.1461 22.792 18.6866 22.792 19.2502C22.792 19.8138 22.5681 20.3543 22.1696 20.7528C21.7711 21.1513 21.2306 21.3752 20.667 21.3752C20.5506 21.3731 20.4346 21.3614 20.3201 21.3401C22.2104 22.0791 23.924 23.2075 25.3498 24.6519C27.7149 22.1244 29.0672 18.8149 29.149 15.3543H24.0868C23.8542 15.355 23.6237 15.3095 23.4088 15.2204C23.1939 15.1314 22.9987 15.0005 22.8348 14.8355Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6672 8.625C21.1438 8.62349 21.607 8.78275 21.9819 9.07705C22.3568 9.37134 22.6215 9.78346 22.7332 10.2468C22.8449 10.7101 22.7971 11.1976 22.5975 11.6304C22.3979 12.0632 22.0581 12.416 21.6332 12.6318L23.3358 14.3346C23.5355 14.5331 23.8055 14.645 24.0871 14.6458H29.1493C29.0675 11.1852 27.7152 7.87573 25.3501 5.34814C23.9243 6.79264 22.2106 7.92105 20.3203 8.66006C20.4348 8.63882 20.5508 8.6271 20.6672 8.625Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.54579 8.62278C7.70807 7.87631 6.04231 6.76213 4.65074 5.34863C2.28567 7.87619 0.933352 11.1856 0.851562 14.6462H8.98346C9.02422 12.6274 9.21216 10.6142 9.54579 8.62278Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2538 0.952148C10.1981 1.32791 7.34919 2.69285 5.1416 4.83877C6.43374 6.15626 7.97569 7.20279 9.6772 7.9171C10.2556 5.00559 11.3167 2.06618 13.2538 0.952148Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.69434 14.6458H14.6464V9.67004C13.1423 9.63486 11.6528 9.36531 10.2317 8.87109C9.92307 10.7817 9.74352 12.711 9.69434 14.6458Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.542 19.2504C18.5433 18.8604 18.6523 18.4784 18.8567 18.1464C19.0612 17.8143 19.3534 17.5452 19.701 17.3685L17.9983 15.6658C17.7986 15.4672 17.5287 15.3554 17.2471 15.3545H15.3545V20.3303C16.7818 20.3639 18.1964 20.607 19.5531 21.0518C19.2449 20.8627 18.9902 20.5979 18.8133 20.2826C18.6363 19.9673 18.5429 19.6119 18.542 19.2504Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3545 8.16277C11.7333 8.65593 13.1821 8.92573 14.646 8.96198V1.24658C12.2343 1.55434 10.9873 4.85101 10.3545 8.16277Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.641 21.8359C18.2636 21.3439 16.8166 21.0748 15.3545 21.0386V28.7915C17.8351 28.4824 19.0497 24.9412 19.641 21.8359Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.232 21.1292C11.653 20.635 13.1425 20.3655 14.6466 20.3303V15.3545H9.69434C9.74359 17.2893 9.9232 19.2186 10.232 21.1292Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3545 1.20898V8.96194C16.8166 8.92576 18.2636 8.65659 19.641 8.16459C19.0497 5.05927 17.8351 1.51801 15.3545 1.20898Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.646 28.754V21.0386C13.1821 21.0748 11.7333 21.3446 10.3545 21.8378C10.9873 25.1495 12.2343 28.4462 14.646 28.754Z",
			fill: "white"
		})
	]
});
export default SvgEnterprisePlanIcon;
